import { lazy } from 'react'

import RevenueGroupsLoader from './revenue-groups/loader'
import PreferencesLoader from './preferences/loader'
import ConnectionsLoader from './connections/loader'
import SquareConnectionLoader from './connections/square/loader'
import XeroConnectionLoader from './connections/xero/loader'

export default {
  RevenueGroups: {
    Component: lazy(() => import('./revenue-groups/RevenueGroups.Page')),
    Loader: RevenueGroupsLoader,
  },
  Preferences: {
    Component: lazy(() => import('./preferences/Preferences.Page')),
    Loader: PreferencesLoader,
  },
  Connections: {
    Component: lazy(() => import('./connections/Connections.Page')),
    Loader: ConnectionsLoader,
    Square: {
      Component: lazy(
        () => import('./connections/square/SquareConnection.Page')
      ),
      Loader: SquareConnectionLoader,
    },
    Xero: {
      Component: lazy(() => import('./connections/xero/XeroConnection.Page')),
      Loader: XeroConnectionLoader,
    },
  },
}
